/* tslint:disable */
/* eslint-disable */
/**
 * AllOfUs Workbench API
 * The API for the AllOfUs workbench.  Throughout, we use integer/int64 in preference to string/date-time because Swagger\'s date formatting is inconsistent between server and client. Time values are stored as milliseconds since the UNIX epoch.  Note: all requests tagged as \"cron\" must have the header X-Appengine-Cron: true, which app engine itself only sets when invoking as a cronjob. See https://cloud.google.com/appengine/docs/standard/java/config/cron#securing_urls_for_cron and o.p.w.interceptors.CronInterceptor which implements the header check. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminWorkspaceObjectsCounts
 */
export interface AdminWorkspaceObjectsCounts {
    /**
     * 
     * @type {number}
     * @memberof AdminWorkspaceObjectsCounts
     */
    cohortCount?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminWorkspaceObjectsCounts
     */
    conceptSetCount?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminWorkspaceObjectsCounts
     */
    datasetCount?: number;
}

/**
 * Check if a given object implements the AdminWorkspaceObjectsCounts interface.
 */
export function instanceOfAdminWorkspaceObjectsCounts(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AdminWorkspaceObjectsCountsFromJSON(json: any): AdminWorkspaceObjectsCounts {
    return AdminWorkspaceObjectsCountsFromJSONTyped(json, false);
}

export function AdminWorkspaceObjectsCountsFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminWorkspaceObjectsCounts {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'cohortCount': !exists(json, 'cohortCount') ? undefined : json['cohortCount'],
        'conceptSetCount': !exists(json, 'conceptSetCount') ? undefined : json['conceptSetCount'],
        'datasetCount': !exists(json, 'datasetCount') ? undefined : json['datasetCount'],
    };
}

export function AdminWorkspaceObjectsCountsToJSON(value?: AdminWorkspaceObjectsCounts | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'cohortCount': value.cohortCount,
        'conceptSetCount': value.conceptSetCount,
        'datasetCount': value.datasetCount,
    };
}

